import { render, staticRenderFns } from "./SkiniverReport.vue?vue&type=template&id=10881c9d&scoped=true&"
import script from "./SkiniverReport.vue?vue&type=script&lang=js&"
export * from "./SkiniverReport.vue?vue&type=script&lang=js&"
import style0 from "./SkiniverReport.vue?vue&type=style&index=0&id=10881c9d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10881c9d",
  null
  
)

export default component.exports

/* chakra-loader */
const installChakraComponents = require("!../../../../node_modules/chakra-loader/lib/install-components.js")
installChakraComponents(component, {CFlex: require('@chakra-ui/vue').CFlex, CBox: require('@chakra-ui/vue').CBox})
